import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sessionId: null,
  conversation: [],
  isLandPageVisible: true,
  isInitialLoading: true,
};

const askSaraSlice = createSlice({
  name: "askSara",
  initialState,
  reducers: {
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    setConversation: (state, action) => {
      state.conversation = action.payload;
    },
    updateConversation: (state, action) => {
      // Accepts a callback: (prev) => newArray
      state.conversation = action.payload(state.conversation);
    },
    setIsLandPageVisible: (state, action) => {
      state.isLandPageVisible = action.payload;
    },
    setIsInitialLoading: (state, action) => {
      state.isInitialLoading = action.payload;
    },
    resetAskClaudeState: () => initialState,
  },
});

export const {
  setSessionId,
  setConversation,
  updateConversation,
  setIsLandPageVisible,
  setIsInitialLoading,
  resetAskClaudeState,
} = askSaraSlice.actions;

export default askSaraSlice.reducer;